import styles from "./index.module.css"
import PropTypes from "prop-types"
import BookingConflictWarning from "pagesV2/pro/Calendar/Tooltips/BookingConflictWarning"
import { getEventColor } from "pagesV2/pro/Calendar/utils"
import { getDefaultCalendarColor, getPrimaryCalendarTextColor, resolveBookingColors } from "pagesV2/pro/Calendar/calendarColorUtils"
import { useTheme } from "context/AntdThemeContext"
import BookingPopover from "pagesV2/pro/Calendar/shared/BookingPopover"
import WaiverBadge from "pagesV2/pro/Calendar/shared/WaiverBadge"
import { getWaiverStatus, getWaiverBadgeLabel, isWaiverAttached } from "pagesV2/pro/Calendar/shared/bookingTileUtils"
import { Flex } from "antd"

const EventBlock = ({ event, eventColor, conflict, setIsBookingModalOpen, setSelectedBookingId, fullHeight, compact, hideTime }) => {
  const { id, startLabel, endLabel, title, multi_day } = event || {}
  const { theme } = useTheme()
  const showWaiverBadge = isWaiverAttached(event)

  const handleClick = () => {
    setIsBookingModalOpen(true)
    setSelectedBookingId(event?.id)
  }

  const displayEndLabel = multi_day ? null : endLabel
  const timeRange = startLabel && displayEndLabel ? `${startLabel} - ${displayEndLabel}` : startLabel || null

  const primaryTextColor = getPrimaryCalendarTextColor(theme)
  const previewColors = resolveBookingColors(event?.color || eventColor, getDefaultCalendarColor(), primaryTextColor, getEventColor)
  const textColor = previewColors.textColor || primaryTextColor
  const blockClassName = compact ? `${styles.eventBlock} ${styles.eventBlockCompact}` : styles.eventBlock

  const timeNode =
    !hideTime && timeRange ? (
      <span className={compact ? styles.eventTimeCompact : styles.eventTime} style={{ color: textColor }}>
        {timeRange}
      </span>
    ) : null
  const titleNode = title ? (
    <span className={compact ? styles.eventTitleCompact : styles.eventTitle} style={{ color: textColor }}>
      {title}
    </span>
  ) : null

  return (
    <BookingPopover booking={event} colors={previewColors}>
      <button
        type="button"
        key={id || title + startLabel + endLabel}
        className={blockClassName}
        style={{
          backgroundColor: previewColors.backgroundColor,
          borderColor: previewColors.borderColor,
          ...(fullHeight ? { height: "100%" } : {})
        }}
        onClick={handleClick}
      >
        <Flex items="center">{timeNode}</Flex>
        <Flex items="center">{titleNode}</Flex>
        {showWaiverBadge && (
          <Flex items="center">
            <WaiverBadge
              status={getWaiverStatus(event)}
              label={getWaiverBadgeLabel(event)}
              colors={previewColors}
            />
          </Flex>
        )}
        {conflict ? <BookingConflictWarning /> : null}
      </button>
    </BookingPopover>
  )
}

EventBlock.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    startLabel: PropTypes.string,
    endLabel: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    color: PropTypes.string,
    multi_day: PropTypes.bool
  }),
  eventColor: PropTypes.string,
  setIsBookingModalOpen: PropTypes.func,
  setSelectedBookingId: PropTypes.func,
  conflict: PropTypes.bool,
  fullHeight: PropTypes.bool,
  compact: PropTypes.bool,
  hideTime: PropTypes.bool
}

export default EventBlock
